<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "outerTopBillCode":"2018010410010904978030",
                "outerBillCode":"2018010317280904908518",
                "billType":5,
                "carCode":"粤TEST01",
                "payValue":0.01,
                "notifyUrl":"http://www.xxx.xin",
                "returnUrl":"http://www.xxx.xin",
                "payDesc":"预定停车",
                "parkCode":"2018010317280904908518",
                "payStartTime":"2018-01-05 15:28:08",
                "payMode":"",
                "attach":""
           },
            responseCode: {"data":{
                "ydtBillCode":"2018010410010904978030",
                "payUrl":"http://www.xxx.xin",
            },"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "支付下单接口",
                t_url: this.commonUrls.test+"payOrder",
                p_url: this.commonUrls.prod+"payOrder",
                precondition: "无",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'outerTopBillCode', info2: '是', info3: 'String', info4: '第三方业务流水号，如停车流水号(一次业务可能多次支付)，长度25以内' },
                        { info1: 'outerBillCode', info2: '是', info3: 'String', info4: '第三方支付流水号，长度25以内' },
                        { info1: 'billType', info2: '是', info3: 'int', info4: '账单类型：0付停车费，2购买月票，4共享租用车车，5预定车位，7补交车费（如需扩展，请联系智慧停车开放平台）' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌，非必填' },
                        { info1: 'payValue', info2: '是', info3: 'decimal', info4: '支付金额，单位元' },
                        { info1: 'notifyUrl', info2: '是', info3: 'String', info4: '支付成功通知地址，支付成功将通知该地址' },
                        { info1: 'returnUrl', info2: '否', info3: 'String', info4: '支付成功回调地址，支付成功后将打开该地址，如不填则默认智慧停车页面' },
                        { info1: 'payDesc', info2: '是', info3: 'String', info4: '支付描述，将会显示到智慧停车账单' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号,将会使用该停车场的支付配置' },
                        { info1: 'payStartTime', info2: '是', info3: 'String', info4: '下单时间，格式为yyyy-MM-dd HH:mm:ss' },
                        { info1: 'payMode', info2: '否', info3: 'String', info4: '支付方式,多个用逗号分隔，填写此字段后支付页面只支持填写的支付方式，值请<url>参考附录:/Api/appendixData#appendixData_0</url>（只支持线上的支付方式）' },
                        { info1: 'attach', info2: '否', info3: 'String', info4: '附加数据，在查询API和支付通知中原样返回，可作为自定义参数使用。' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'ydtBillCode', info2: '是', info3: 'String', info4: '智慧停车支付流水号' },
                          { info1: 'payUrl', info2: '是', info3: 'String', info4: '支付地址' },
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/ydtPay/payOrder.vue